// extracted by mini-css-extract-plugin
export default {"btn":"cookieConsentir_btn__6RJip","p":"cookieConsentir_p__RvUnB","Link":"cookieConsentir_Link__7ug9n"};